export default function removeDuplicateSlashes(str: string) {
    return str.replace(/\/{2,}/g, '/');
}